import { ComponentPropsWithoutRef } from 'react';

import { DashboardsMenu } from './components/DashboardsMenu';
import { Menu } from './components/Menu';
import { useAutoExpand, useMenu } from './hooks';

import { AppContainerWithMenuStyled, Content, MenuContainer } from './AppContainerWithMenu.styles';

export type AppContainerWithMenuProps = ComponentPropsWithoutRef<'div'>;

export function AppContainerWithMenu({ children, ...props }: AppContainerWithMenuProps) {
  const { isFullMenuVisible, isDashboardMenuVisible } = useMenu();

  useAutoExpand();

  return (
    <AppContainerWithMenuStyled
      aria-expanded={isFullMenuVisible || isDashboardMenuVisible}
      data-is-full-menu-visible={isFullMenuVisible}
      data-is-category-dashboard-visible={isDashboardMenuVisible}
      {...props}
    >
      <MenuContainer>
        <Menu />
        <DashboardsMenu />
      </MenuContainer>
      <Content>{children}</Content>
    </AppContainerWithMenuStyled>
  );
}
